import { defineMessage } from 'services/localization';

export const messages = {
    successPay: defineMessage('all_payments_are_succes_he_airwallex_processing'),
};
